import { cn } from "lib/utils";
import React from "react";

import searchError from "assets/images/totem/search-error.svg";
import { ActionButton } from "../ActionButton";
import { TotemHeader } from "../TotemHeader";

type Props = { onRetry: () => void; onHome: () => void };

export const NoAppointmentScreen: React.FC<Props> = ({ onRetry, onHome }) => (
	<main
		className={cn(
			"mx-auto flex min-h-full w-full max-w-[800px] flex-col items-center gap-14 bg-white px-6 pb-14 pt-8 max-[1023px]:px-5 max-[1023px]:pb-10 max-[1023px]:pt-6 max-[639px]:gap-8 max-[639px]:px-3 max-[639px]:pb-8 max-[639px]:pt-4",
		)}
	>
		<section
			className={cn(
				"relative h-[924px] w-full shrink-0 max-[639px]:h-[680px]",
			)}
		>
			<div
				className={cn(
					"absolute inset-x-0 top-14 flex h-[868px] flex-col items-center gap-3 bg-[#F3F4F6] px-14 pt-24 text-center max-[1023px]:top-12 max-[1023px]:px-8 max-[1023px]:pt-20 max-[639px]:top-10 max-[639px]:h-[640px] max-[639px]:px-4 max-[639px]:pt-20",
				)}
			>
				<img src={searchError} alt="" className={cn("h-24 w-24")} />
				<h1
					className={cn(
						"mt-6 w-full font-sans text-[32px] font-bold leading-normal text-[#1D293D] max-[639px]:text-[24px]",
					)}
				>
					Não encontramos o agendamento
				</h1>
				<p
					className={cn(
						"w-full font-sans text-[24px] leading-normal text-[#45556C] max-[639px]:text-[17px]",
					)}
				>
					Não há agendamentos de hoje para os dados informados.
				</p>
			</div>
			<TotemHeader />
		</section>
		<div className={cn("flex w-full flex-col gap-8")}>
			<ActionButton onClick={onRetry}>Tentar novamente</ActionButton>
			<ActionButton variant="secondary" direction="back" onClick={onHome}>
				Voltar ao início
			</ActionButton>
		</div>
	</main>
);
